export const fetchLiveMetrics = "/analytics/live/metrics"
export const fetchMetrics = "/analytics/history/logsData"
export const fetchSessionData = "/analytics/history/sessionData"
export const fetchCampaignRecordsData = "/analytics/history/campaignRecordsData"
export const fetchGraphRefreshData = "/analytics/history"
